import React   from 'react';
import { makeStyles } from '@material-ui/core/styles'; 
 const useStyles = makeStyles({
    todoListActions: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: 100,
        textAlign:'center'
    },
    todoSection: {
        flex: 1,
        height: 87,
        padding: 10,
        backgroundColor: 'rgba(255, 255, 255, 1)',
        border: '1px solid rgba(255, 255, 255, 1)',
        opacity: 1,
        fontFamily: 'Poppins',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '18px',
        color: 'rgba(181, 181, 195, 1)',
        position: 'relative',
        paddingTop: 20,
        paddingBottom:10,
        paddingLeft: 17
    },
    firstSection: {
        borderTopLeftRadius: 9,
        borderBottomLeftRadius: 9,
        paddingTop: 20
    },
    lastSection: {
        borderTopRightRadius: 9,
        borderBottomRightRadius: 9,
        paddingTop: 20
    },
    sectionLine: {
        content: '""',
        position: 'absolute',
        top: 7,
        bottom: 5,
        right: 0,
        width: 1,
        backgroundColor: 'rgba(244, 241, 249, 1)',
    },
    sectionText: {
        fontFamily: 'Poppins',
        fontSize: 20,
        fontWeight: 600,
        color: 'rgba(70, 78, 95, 1)',
        display: 'block',
        paddingLeft: 0,
        marginTop: 5,
    },
});

const ReplacementCarInfo = ({loading , replacementCarRequestsData}) => {
    const classes = useStyles();


    if (loading) return <div>Loading...</div>;  

     if (!replacementCarRequestsData.length) {
         return <div></div>;
     }
     const demandeCount = replacementCarRequestsData.length;
     const demandeEnAttente = replacementCarRequestsData.filter((demande) => demande.replacementStatus === 'PENDING').length;
     const demandeRejette = replacementCarRequestsData.filter((demande) => demande.replacementStatus === 'REJECTED').length;
     const demandeCloture = replacementCarRequestsData.filter((demande) => demande.replacementStatus === 'APPROVED').length;

    return (
        <div className={classes.todoListActions}>
            <div className={`${classes.todoSection} ${classes.firstSection}`}>
                Total demandes
                <span className={classes.sectionText}>
                    {demandeCount}
                </span>
                <span className={classes.sectionLine}></span>
            </div>
            <div className={classes.todoSection}>
                Demande en attente
                <span className={classes.sectionText}>
                    {demandeEnAttente}
                </span>
                <span className={classes.sectionLine}></span>
            </div>
            <div className={classes.todoSection}>
                Demande Rejetée
                <span className={classes.sectionText}>
                    {demandeRejette}
                </span>
                <span className={classes.sectionLine}></span>
            </div>
            <div className={classes.todoSection}>
                Demande cloturée
                <span className={classes.sectionText}>
                    {demandeCloture}
                </span>
                <span className={classes.sectionLine}></span>
            </div>
      
        </div>
      
    );
};

export default ReplacementCarInfo;
